import { render, staticRenderFns } from "./BasisForm.vue?vue&type=template&id=75179bf7&"
import script from "./BasisForm.vue?vue&type=script&lang=js&"
export * from "./BasisForm.vue?vue&type=script&lang=js&"
import style0 from "./BasisForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports